import React from 'react';
import PropTypes from 'prop-types';
import Accordion from './Accordion';

const AccordionGroup = ({ content }) => {
  let accordionList;
  if (content.length > 0) {
    accordionList = (
      <ul className="faux-list">
        {content.map((accordion, index) =>
          // We don't have a unique ID here so we use the index instead. The list
          // order never changes so it shouldn't be a problem in this instance.
          // eslint-disable-next-line react/no-array-index-key
          <li key={index}><Accordion title={accordion.title} detail={accordion.detail} /></li>,
        )}
      </ul>
    );
  }

  return (
    <div className="accordion-group">
      {accordionList}
    </div>
  );
};

AccordionGroup.propTypes = {
  content: PropTypes.array,
};

export default AccordionGroup;



// WEBPACK FOOTER //
// ./library/app/components/Content/AccordionGroup.js